import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Content = styled.div`
  padding: 0;
  ${media.phoneMedium} {
    padding: 0 ${rem(32)};
  }
  ${media.tabletMedium} {
    padding: 0 ${rem(120)} 0 ${rem(100)};
  }
`;

export default Content;
